import React from 'react'
import { EmailsTable } from 'components/Tables/EmailsTable/EmailsTable'
import { ContactCompany } from 'models/companies'
import { CompanyModal } from '../CompanyModal'

interface EmailsModalProps {
  show: boolean
  onHide: () => void
  contactCompany: ContactCompany
  forDoorProxyId?: number
  companyName?: string
}

export function EmailsModal({
  show,
  onHide,
  contactCompany,
  forDoorProxyId,
  companyName,
}: EmailsModalProps) {
  const TABLE_KEY = forDoorProxyId
    ? `emails-modal-door-${forDoorProxyId}`
    : `emails-modal-company-${contactCompany.id}`

  return (
    <CompanyModal
      show={show}
      onHide={onHide}
      companyName={companyName || contactCompany.name}
      modalTitle="Emails"
    >
      <div style={{ height: '60vh', display: 'flex', flexDirection: 'column' }}>
        <EmailsTable
          tableKey={TABLE_KEY}
          forChainProxyId={contactCompany.id}
          forDoorProxyId={forDoorProxyId}
          disableUrlPagination
          disableExportButton
        />
      </div>
    </CompanyModal>
  )
}
